import {
  Box,
  ContentBlock,
  Heading,
  Hidden,
  IconChevron,
  Inline,
  Link,
  MenuItem,
  MenuItemLink,
  MenuRenderer,
  Spread,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';

import Logo from '../../images/apfa-logo@2x.png';

interface Props {
  size?: 'small' | 'full';
}

export const Header = ({ size = 'small' }: Props) => (
  <Box
    padding="gutter"
    background="customDark"
    style={{ backgroundColor: '#133054' }}
  >
    <ContentBlock>
      <Spread direction="horizontal" space="gutter" alignY="center">
        <Link href="/">
          <Box
            style={{
              backgroundImage: `url(${Logo})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              width: size === 'small' ? '174px' : '338px',
              height: size === 'small' ? '53px' : '103px',
            }}
          />
        </Link>
        <Box
          style={{
            clip: 'rect(1px,1px,1px,1px)',
            height: '1px',
            whiteSpace: 'nowrap',
            width: '1px',
            overflow: 'hidden',
          }}
        >
          <Heading level="1" align="center">
            <span style={{ textIndent: '-999px' }}>Amsleigh Park PFA</span>
          </Heading>
        </Box>
        <Hidden below="tablet">
          <Inline space="gutter">
            <Text>
              <TextLink href="/calendar" weight="weak">
                Calendar
              </TextLink>
            </Text>
            <Text>
              <TextLink href="/community-directory" weight="weak">
                Community Directory
              </TextLink>
            </Text>
          </Inline>
        </Hidden>
        <Hidden above="tablet">
          <MenuRenderer
            offsetSpace="small"
            trigger={(triggerProps, { open }) => (
              <Box userSelect="none" cursor="pointer" {...triggerProps}>
                <Text>
                  Menu{' '}
                  <IconChevron
                    direction={open ? 'up' : 'down'}
                    alignY="lowercase"
                  />
                </Text>
              </Box>
            )}
          >
            <MenuItemLink href="/about">About</MenuItemLink>
            <MenuItemLink href="/calendar">Calendar</MenuItemLink>
            <MenuItemLink href="/community-directory">
              Community Directory
            </MenuItemLink>
            <MenuItemLink href="/contact">Contact</MenuItemLink>
          </MenuRenderer>
        </Hidden>
      </Spread>
    </ContentBlock>
  </Box>
);
